module.exports = __webpack_public_path__ + "img/step2.a484547e.png";